import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { getNoticeDetails } from '../../../api/notice';

interface NoticeDetailsData {
  title: string;
  createdAt: string;
  content: string;
}

const NoticeDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<NoticeDetailsData>();

  useEffect(() => {
    const getNoticeDetailsData = async () => {
      try {
        const response = await getNoticeDetails(Number(id));
        setData(response);
      } catch (error) {}
    };

    getNoticeDetailsData();
  }, []);
  return (
    <Container>
      <div className="content-title">
        <span className="title">{data?.title}</span>
        <div className="sub">
          <span className="writer">관리자</span>
          <span className="date">{data?.createdAt}</span>
        </div>
      </div>
      <div className="contents">
        <div className="text-box">{data?.content}</div>
      </div>
    </Container>
  );
};

export default NoticeDetail;

//style
const Container = styled.div`
  padding: 0 1.5rem;
  .content-title {
    margin-top: 2.4rem;
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    .title {
      font-size: 2.4rem;
      font-weight: 600;
      color: ${(props) => props.theme.textBlackColor};
    }
    .sub {
      display: flex;
      gap: 2.3rem;
      span {
        font-size: 1.4rem;
        font-weight: 400;
        color: ${(props) => props.theme.textAAAColor};
        display: flex;
      }
      .writer {
        color: ${(props) => props.theme.btnBlueColor};
      }
      .date {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: -1.2rem;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 1.2rem;
          background-color: ${(props) => props.theme.textAAAColor};
        }
      }
    }
  }
  .contents {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-top: 4.3rem;
    .title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .text-box {
      flex: 1;
      overflow: hidden;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 1.4;
      white-space: pre-line;
    }
  }
  .answer-contents {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-top: 4rem;
    .title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .text-box {
      padding: 1.9rem 1.6rem;
      min-height: 10rem;
      background-color: ${(props) => props.theme.costBgColor};
      border-radius: 1.6rem;
      flex: 1;
      overflow: hidden;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 1.4;
      white-space: pre-line;
    }
  }
`;

const Btn = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 9.4rem;
  border: none;
  outline: none;
  padding: 1.7rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: ${(props) => props.theme.btnStrongBlueColor};
  color: ${(props) => props.theme.textWhiteColor};
  font-size: 1.8rem;
  font-weight: 600;
`;
